import type { ManageRoomNavigationProps } from './manage-room-navigation.types';
import { faChevronUp, faEye, faLock } from '@fortawesome/pro-regular-svg-icons';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { useFeature } from 'src/common/growthbook';
import RightArrowSvg from 'src/images/svgs/manage-room/right-arrow.svg';
import { cloudIntegrationTab, manageRoomTabs } from './manage-room-navigation.constants';
import { StyledBar, StyledChevronUp, StyledEllipsesIcon, StyledIcon, StyledImg, StyledLine, StyledNavigationContainer, StyledNewTag, StyledOption, StyledOptionName, StyledOptionWrapper, StyledPublicTag, StyledPublicTagIcon, StyledResponsiveContainer } from './manage-room-navigation.styles';
export const ManageRoomNavigation = ({
  isContentDev,
  selectedTab,
  onSelectedTab,
  isPublicRoom
}: ManageRoomNavigationProps) => {
  const [expanded, setExpanded] = React.useState<boolean>(true);
  const isRoomVersionControlEnabled = useFeature('room-version-control').on;
  let tabs = manageRoomTabs;
  if (isContentDev) {
    tabs = [...tabs.slice(0, 1), cloudIntegrationTab, ...tabs.slice(1)];
  }

  // Filter out version control tab if feature flag is disabled
  tabs = tabs.filter(tab => tab.key !== 'version-control' || isRoomVersionControlEnabled);
  return <StyledNavigationContainer aria-label="Manage room navigation" data-sentry-element="StyledNavigationContainer" data-sentry-component="ManageRoomNavigation" data-sentry-source-file="manage-room-navigation.tsx">
      {expanded ? <>
          <StyledPublicTag isPublic={isPublicRoom}>
            <StyledPublicTagIcon isPublic={isPublicRoom} icon={isPublicRoom ? faEye : faLock} />
            {isPublicRoom ? 'Public room' : 'Private room'}
          </StyledPublicTag>

          {tabs.map(tab => {
        const isSelected = selectedTab.key === tab.key;
        const isVersionControl = tab.key === 'version-control';
        return <StyledOptionWrapper key={tab.key}>
                {isSelected && <StyledImg alt="Selected Option" src={RightArrowSvg} />}

                <StyledOption isSelected={isSelected} aria-label={`${tab.name}`} onClick={() => onSelectedTab(tab)}>
                  <StyledIcon icon={isSelected ? tab.selectedIcon : tab.icon} />
                  <StyledOptionName>{tab.name}</StyledOptionName>
                  {isVersionControl && <StyledNewTag>NEW</StyledNewTag>}
                </StyledOption>
              </StyledOptionWrapper>;
      })}
        </> : <StyledOptionWrapper>
          <StyledImg alt="Selected Option" src={RightArrowSvg} />
          <StyledOption isSelected aria-label={`${selectedTab.name}`}>
            <StyledIcon icon={selectedTab.selectedIcon} />
            <StyledOptionName>{selectedTab.name}</StyledOptionName>
            {selectedTab.key === 'version-control' && <StyledNewTag>NEW</StyledNewTag>}
          </StyledOption>

          <StyledEllipsesIcon icon={faEllipsisV} onClick={() => setExpanded(true)} />
        </StyledOptionWrapper>}

      {expanded && <StyledResponsiveContainer>
          <StyledLine />
          <StyledChevronUp data-testid="chevronup-icon" icon={faChevronUp} onClick={() => setExpanded(!expanded)} />
        </StyledResponsiveContainer>}

      <StyledBar data-sentry-element="StyledBar" data-sentry-source-file="manage-room-navigation.tsx" />
    </StyledNavigationContainer>;
};